import BackToTopCom from 'components/common/scroll-to-top';
import React, { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { animationCreate } from 'utils/utils';
import { isRionickSitePage } from 'utils/rionick-pages';

const Wrapper = ({children}) => {
  const { pathname } = useLocation();

  useEffect(() => {
    setTimeout(() => {
      animationCreate()
    }, 200);
  },[])

  // Site-wide UI refinements (_rionick-site.scss) apply only to main Rionick pages.
  // Layout effect: the class lands before first paint, so theme transitions
  // (e.g. `transition: all` on headings) don't animate from the old styles.
  useLayoutEffect(() => {
    const isSitePage = isRionickSitePage(pathname);
    document.body.classList.toggle('rionick-site', isSitePage);
    return () => document.body.classList.remove('rionick-site');
  }, [pathname]);

  return (
    <>
      {children}
      <BackToTopCom />
    </>
  );
};

export default Wrapper;
